module.exports = __webpack_public_path__ + "static/media/man.72ed7173.png";